import { createSlice } from "@reduxjs/toolkit";
import { fetchEarnings } from "./apiThunk";

const initialState = {
    earnings: {},
    loading: false,
    error: null,
  };

const paymentsSlice = createSlice({
  name: "payments",
  initialState,
  reducers: {
    clearEarnings: (state) => {
      state.earnings = {};
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchEarnings.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchEarnings.fulfilled, (state, action) => {
      state.loading = false;
      state.earnings = action.payload;
    });
    builder.addCase(fetchEarnings.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
  },
});

const { reducer } = paymentsSlice;
export { fetchEarnings };
export default reducer;
